import React, { useEffect, useState } from "react";
import Checkinpopup from "../common/Checkinpopup";
import Checkinpopup2 from "../common/Checkinpopup2";
import Checkinpopup3 from "../common/Checkinpopup3";
import BackButton from "./BackButton";
import $ from "jquery";

const errorStyle = {
  color: "red",
};
const Checkin = (props) => {
  const [benscheme, setBenScheme] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [buttonIcon, setButtonIcon] = useState(false);
  const [otherschemeError, setOtherschemeError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otherScheme, setOtherScheme] = useState("");
  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [lat, setLat] = useState();
  const [long, setLong] = useState();
  const [location_status, setLocation_status] = useState("success");
  const [locpopup, setLocpopup] = useState(false);
  const [popup3, setPopup3] = useState(false);

  useEffect(() => {
    localStorage.removeItem("location_status");
    // try {
    //   let obj = {};
    //   window.gtag("event", "Image Upload successfully", obj);
    // } catch (error) { }
    // getLocation();
  }, []);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      // alert('Geolocation is not supported by this browser.')
      console.log("Geolocation is not supported by this browser.");
    }
  };

  const showPosition = (position) => {
    setLat(position.coords.latitude);
    setLong(position.coords.longitude);
    submitHandler(position.coords.latitude, position.coords.longitude);
  };

  const showError = (error) => {
    // alert("into show error");
    $(".loader_bg").hide();
    console.log("error is", error);
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.log("User denied the request for Geolocation.");
        setLocation_status("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        console.log("Location information is unavailable.");
        setLocation_status("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        console.log("The request to get user location timed out.");
        setLocation_status("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        console.log("An unknown error occurred.");
        setLocation_status("An unknown error occurred.");
        break;
    }
    setLocpopup(true);
  };

  const handleSelect = (e) => {
    if (e.target.value === "Other" || e.target.value === "") {
      setSelectedItem(e.target.value);
      setBenScheme(e.target.value);
      setButtonIcon(false);
    } else {
      setBenScheme(e.target.value);
      setOtherScheme("");
      setSelectedItem("");
      setButtonIcon(true);
    }
  };

  function camelize(text) {
    const words = text.split(" ");
    for (let i = 0; i < words.length; i++) {
      if (words[i] && words[i].length > 0) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }
    }

    return words.join(" ");
  }

  const handleChangeWithCamelize = (e) => {
    const copyE = { ...e };
    copyE.target.value = camelize(copyE.target.value);
    // handleChange(e);
    setOtherScheme(e.target.value);
    if (e.target.value) {
      setButtonIcon(true);
      setOtherschemeError(false);
    } else {
      setButtonIcon(false);

      setOtherschemeError(true);
    }
  };
  const handleChange = (e) => {
    setBenScheme(e.target.value);
    setButtonIcon(true);
  };

  var options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };



  function success(pos) {
    var crd = pos.coords;
    console.log("Successfully determined a user position:", crd);
    submitHandler(crd.latitude, crd.longitude);

  }
  function error(err) {
    console.warn(`ERROR(${err.code}): ${err.message}`);
    showError()
  }

  const checkInHandler = () => {
    $("body").css("overflow", "hidden");
    if (navigator.geolocation) {
      //  navigator.geolocation.getCurrentPosition(showPosition, showError);
      navigator.geolocation.getCurrentPosition(success, error, options);
    } else {
      // $(".loader_bg").hide();
      // setLocpopup(true);
      // setPopup3(false);
      // setShowLocationPopup(false);
      // alert('Geolocation is not supported by this browser.')
      console.log("Geolocation is not supported by this browser.");
    }
  };

  const submitHandler = (latitude, longitude) => {
    setLoading(true);

    let numOfError = 0;

    let latval = latitude && latitude.toString();
    let longval = longitude && longitude.toString();

    console.log("latlong", latval, " longval", longval);

    if (benscheme === "Other") {
      if (!otherScheme) {
        numOfError += 1;
        setOtherschemeError(true);
      } else {
        setOtherschemeError(false);
      }
    }

    if (numOfError >= 1) {
      setLoading(false);
      $(".loader_bg").hide();
      return false;
    }
    let dataObj = {
      beniname: benscheme ? benscheme : "",
      lat: latval,
      long: longval,
    };
    props.getData(dataObj);
    if (
      latval == "undefined" ||
      longval == "undefined" ||
      !latval ||
      !longval
    ) {
      // props.nextpage('checkinpopup2')
      setLocpopup(true);
      setPopup3(false);
      $(".loader_bg").hide();
    } else {
      // props.nextpage('checkinpopup');
      $(".loader_bg").hide();
      setShowLocationPopup(true);
    }
    $(".loader_bg").hide();
  };

  const closeCheckinPopup = () => {
    setShowLocationPopup(false);
    $("body").css("overflow", "auto");
  };
  const hideSlide = () => {
    $("body").css("overflow", "auto");
    setLocpopup(false);
    setPopup3(false);
  };

  const submit = () => {
    // checkInHandler();
    $("body").css("overflow", "hidden");
    setPopup3(true);
    setLocpopup(false);
  };

  console.log("latlong", lat, "long", long);

  const close = () => props.nextpage("upload");
  return (
    <>
      <div className="checkinback_bg">
        <BackButton close={close} />
      </div>
      <div className="checkinbg">
        <div className="container">
          <div className="checkin_content">
            <h4>Check-in with a beneficiary</h4>

            <div className="check_sel_div">
              <h5>Select Category</h5>
              <div className="select_arrow">
                <select value={benscheme} onChange={(e) => handleSelect(e)}>
                  <option selected="" disabled="" value="">
                    Select
                  </option>
                  <option value="Gareeb Kalyan Ann Yojana">
                    Gareeb Kalyan Ann Yojana
                  </option>
                  <option value="Ujjawala Yojana">Ujjawala Yojana</option>
                  <option value="Jal Jeevan Mission">Jal Jeevan Mission</option>
                  <option value="Saubhagya Yojana">Saubhagya Yojana</option>
                  <option value="Ujala Yojana">Ujala Yojana</option>
                  <option value="Mudra">Mudra</option>
                  <option value="Jan Dhan Yojana">Jan Dhan Yojana</option>
                  <option value="Swachh Bharat">Swachh Bharat </option>
                  <option value="Ayushman Bharat">Ayushman Bharat</option>
                  <option value="PM Kisan Yojana">PM Kisan Yojana</option>
                  <option value="Awas Yojana">Awas Yojana</option>
                  <option value="Covid Vaccination">Covid Vaccination</option>
                  <option value="Free Toilet Construction">
                    Free Toilet Construction
                  </option>
                  <option value="Vidhwa Pension Yojana">
                    Vidhwa Pension Yojana
                  </option>
                  <option value="Sukanya Samriddhi Yojana (SSY)">
                    Sukanya Samriddhi Yojana (SSY)
                  </option>
                  <option value="Pradhan Mantri Matritva Vandana Yojana (PMMVY)">
                    Pradhan Mantri Matritva Vandana Yojana (PMMVY)
                  </option>
                  <option value="Other">Other</option>
                </select>

                <img
                  src="/assets/images/arrowdownselect.svg"
                  className="arrowselect_down"
                  alt=""
                />
              </div>

              <h6>Please enable your location to complete check-in</h6>
              
            </div>
            {selectedItem === "Other" && (
              <div className="otherlabel">
                <h5>Other Scheme</h5>
                <input
                  type="text"
                  className="otherform"
                  value={otherScheme}
                  onChange={(e) => handleChangeWithCamelize(e)}
                  onBlur={(e) =>
                    e.target.value
                      ? setOtherschemeError(false)
                      : setOtherschemeError(true)
                  }
                />
                {otherschemeError && (
                  <p style={errorStyle}>Please enter a scheme name.</p>
                )}
              </div>
            )}
            {buttonIcon && (
              <div className="next_btn">
                <a href="#" onClick={(e) => checkInHandler(e)}>
                  Check-In
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <Checkinpopup />
            <Checkinpopup2 />
            <Checkinpopup3 /> */}

      {showLocationPopup && (
        <Checkinpopup
          close={closeCheckinPopup}
          getData={props.getData}
          nextpage={props.nextpage}
          data={props.data}
        />
      )}
      {locpopup && (
        <Checkinpopup2
          benName={benscheme}
          hideSlide={hideSlide}
          submit={submit}
          checkInHandler={checkInHandler}
          nextpage={props.nextpage}
        />
      )}
      {popup3 && (
        <Checkinpopup3 hideSlide={hideSlide} nextpage={props.nextpage} />
      )}
    </>
  );
};

export default Checkin;
